import { useEffect } from "react";

function Filter({setActiveGenre, activeGenre, setFiltered, popular}) {

    useEffect(() => {
        if (activeGenre === 0) {
            setFiltered(popular);
            return;
        }
        const filtered = popular.filter((movie) => movie.genre_ids.includes(activeGenre));
        setFiltered(filtered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeGenre]);

    return(
        <div className="filter-container">
            <button className={activeGenre === 0 ? "active" : ""} onClick={() => setActiveGenre(0)}>All</button>
            <button className={activeGenre === 12 ? "active" : ""} onClick={() => setActiveGenre(12)}>Adventure</button>
            <button className={activeGenre === 16 ? "active" : ""} onClick={() => setActiveGenre(16)}>Animation</button>
            <button className={activeGenre === 28 ? "active" : ""} onClick={() => setActiveGenre(28)}>Action</button>
            <button className={activeGenre === 10749 ? "active" : ""} onClick={() => setActiveGenre(10749)}>Romance</button>
        </div>
    )
}

export default Filter;